import { createAppKit } from "@reown/appkit/react";
import { WagmiProvider } from "wagmi";
import { sepolia } from "@reown/appkit/networks";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { WagmiAdapter } from "@reown/appkit-adapter-wagmi";

// 0. Setup queryClient
const queryClient = new QueryClient();

// 1. Get projectId from https://dashboard.reown.com
const projectId = "b95e7100ff675d2c22ccb5b020b06225";

// 2. Create a metadata object - optional
const metadata = {
  name: "Soli Coin NFT",
  description: "Soli Coin NFT Marketplace Website",
  url: "https://solicoin.ai", // origin must match your domain & subdomain
  icons: ["https://solicoin.ai/images/icon.svg", "*"],
};

// 3. Set the networks
const networks = [sepolia];

// 4. Create Wagmi Adapter
const wagmiAdapter = new WagmiAdapter({
  networks,
  projectId,
  ssr: true,
});

// 5. Create modal
createAppKit({
  adapters: [wagmiAdapter],
  networks,
  projectId,
  metadata,
  features: {
    analytics: true, // Optional - defaults to your Cloud configuration
  },
});

export function AppKitProvider({ children }) {
  return (
    <WagmiProvider config={wagmiAdapter.wagmiConfig}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </WagmiProvider>
  );
}
